import { render, staticRenderFns } from "./LandingPhoneModal.vue?vue&type=template&id=72008bad&scoped=true"
import script from "./LandingPhoneModal.vue?vue&type=script&lang=js"
export * from "./LandingPhoneModal.vue?vue&type=script&lang=js"
import style0 from "./LandingPhoneModal.vue?vue&type=style&index=0&id=72008bad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72008bad",
  null
  
)

export default component.exports